import config from "../config/config";
import axios from "axios";
import { getToken } from "../Token";
import * as url from "../helpers/url_helper";
import { getTimezoneInfo } from '../helpers/timezone_helper';

const { timezoneName, formattedOffset } = getTimezoneInfo();
const token = getToken();

export const BookingApi = {
   getAllBookings: async (data) => {
    const params = new URLSearchParams(data).toString();
    const axiosConfig = {
        method: 'get', // <-- Change to GET
        url: `${config.API_URL}${url.GET_ALL_BOOKINGS}?${params}`, // <-- Send salon_id as query param
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            "Timezone-Name": timezoneName,
            "Timezone-Offset": formattedOffset,
        }
    };
    return await axios(axiosConfig);
},
    getBookingById: async (id) => {
  const axiosConfig = {
    method: "get",
    url: `${config.API_URL}/${url.GET_BOOKING_BY_ID}/${id}`, // ✅ fixed
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Timezone-Name": timezoneName,
      "Timezone-Offset": formattedOffset,
    },
  };
  return await axios(axiosConfig);
},


    createBooking: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.CREATE_BOOKING}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };
        return await axios(axiosConfig);
    },

    updateBooking: async (data) => {
        const axiosConfig = {
            method: 'put',
            url: `${config.API_URL}${url.UPDATE_BOOKING}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };
        return await axios(axiosConfig);
    },

    deleteBooking: async (id) => {
        const axiosConfig = {
            method: 'delete',
            url: `${config.API_URL}${url.DELETE_BOOKING}/${id}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            }
        };
        return await axios(axiosConfig);
    }
}